var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "detalhe-container" }, [
    _c(
      "div",
      { staticClass: "detalhe-coluna" },
      [
        _c("div", { staticClass: "master-detail-caption" }, [
          _vm._v("Lotes de Estocagem"),
        ]),
        _vm._v(" "),
        _c(
          "DxDataGrid",
          {
            attrs: {
              "data-source": _vm.dataSourceLotes,
              "show-borders": true,
              "column-auto-width": true,
              "no-data-text": "Sem lotes de estocagem",
            },
          },
          [
            _c("DxSorting", {
              attrs: {
                "ascending-text": "Ordem crescente",
                "descending-text": "Ordem descrescente",
                "clear-text": "Limpar ordenação",
              },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: {
                caption: "Lote estocagem",
                "data-field": "LoteEstocagem",
              },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: {
                caption: "Data da movimentação",
                "data-field": "DataMovimentacao",
                "data-type": "date",
              },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: {
                caption: "Data de vencimento",
                "data-field": "DataVencimento",
                "data-type": "date",
              },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: { caption: "Quantidade", "data-field": "Quantidade" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "detalhe-coluna" },
      [
        _c("div", { staticClass: "master-detail-caption" }, [
          _vm._v("Lotes Internos"),
        ]),
        _vm._v(" "),
        _c(
          "DxDataGrid",
          {
            attrs: {
              "data-source": _vm.dataSourceLotesInternos,
              "show-borders": true,
              "column-auto-width": true,
              "no-data-text": "Sem lotes internos",
            },
          },
          [
            _c("DxSorting", {
              attrs: {
                "ascending-text": "Ordem crescente",
                "descending-text": "Ordem descrescente",
                "clear-text": "Limpar ordenação",
              },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: { caption: "Lote", "data-field": "Lote" },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: { caption: "Quantidade", "data-field": "Quantidade" },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: {
                caption: "Valor Unitário",
                "data-field": "ValorUnitario",
                format: "R$ #,##0.00",
              },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: {
                caption: "Valor Total",
                "data-field": "ValorTotal",
                format: "R$ #,##0.00",
              },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: { caption: "Cancelado", "data-field": "Cancelado" },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }